import { render, staticRenderFns } from "./main-news-slide.vue?vue&type=template&id=ca0b9f9c&scoped=true"
import script from "./main-news-slide.vue?vue&type=script&lang=js"
export * from "./main-news-slide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0b9f9c",
  null
  
)

export default component.exports